// extracted by mini-css-extract-plugin
export default {"button":"SaveButton_button__mT2WG"};